// Based on react-scroll-sync implementation, but only syncs horizontal scroll.
const onScroll = (
  scrolledElement: HTMLDivElement | null,
  otherElement: HTMLDivElement | null,
) => {
  if (!(scrolledElement && otherElement)) {
    return
  }

  if (otherElement.scrollLeft !== scrolledElement.scrollLeft) {
    otherElement.scrollLeft = scrolledElement.scrollLeft
  }
}

export const addScrollEvent = (
  element: HTMLDivElement | null,
  otherElement: HTMLDivElement | null,
) => {
  let ignoreScroll = false
  if (element && otherElement) {
    element.onscroll = () => {
      if (ignoreScroll) {
        ignoreScroll = false
      } else {
        onScroll(element, otherElement)
        ignoreScroll = true
      }
    }

    otherElement.onscroll = () => {
      if (ignoreScroll) {
        ignoreScroll = false
      } else {
        onScroll(otherElement, element)
        ignoreScroll = true
      }
    }
  }
}

export const removeScrollEvent = (element: HTMLDivElement | null) => {
  if (element) {
    element.onscroll = null
  }
}
